import useRules, { useMust, useRule, useLeast } from '@/util/useRules'
import { t } from '@/plugins/i18n'

export default (props: any, model: any): any => {
  const needChangeThings = {
    msg: t('请大致描述一下希望改动哪些方面,如:材质、设计、颜色、尺寸等'),
    fns: [
      () =>
        props.data.questionClassificationName !== 'A' &&
        props.data.stylebookUrl,
      () => model.needChangeThings || model.needChangeThingsUrl
    ]
  }
  const productImg = {
    msg: t('链接和图片必须填一个'),
    fns: [
      () => {
        // 排除以下几种情况
        return !(
          ['A', 'D'].includes(props.data.clothingQuestionInitialRequirement) ||
          ['B'].includes(props.data.canOffer) ||
          props.data.ingredientsId === ''
        )
      },
      () => model.productImg || model.productUrl
    ]
  }
  const rules = {
    // 样品寄出物流单号
    logisticsNo: [],
    // 面料信息
    fabricInfo: useMust(t('请填写具体的面料材质信息')),
    // 需求描述
    needChangeThings: useLeast(needChangeThings),
    needChangeThingsUrl: useLeast(needChangeThings),
    // 式样书
    stylebookUrl: useMust(t('请上传式样书')),
    // 面料信息
    fabricDesc: useMust(
      t('请大致描述一下希望布料的外观或功能上的需求，如:弹性好，柔软等')
    ),
    // 色卡信息
    colorCard: useLeast({
      msg: t('请至少选择或上传一种色卡'),
      fns: () => model.colorCard?.length || model.colorCardUrl
    }),
    // 辅料信息
    ingredientsStyleId: useLeast({
      msg: t('请填写款式说明'),
      fns: [
        () => model.ingredientsStyleId && model.ingredientsStyleId !== 'custom',
        () => model.ingredientsStyleDesc
      ]
    }),
    ingredientsMaterialsId: useLeast({
      msg: t('请填写材质详细说明'),
      fns: [
        () =>
          model.ingredientsMaterialsId &&
          model.ingredientsMaterialsId !== 'custom',
        () => model.ingredientsMaterialsDesc
      ]
    }),
    ingredientsSizeId: useLeast({
      msg: t('请填写尺寸详细说明'),
      fns: [
        () => model.ingredientsSizeId && model.ingredientsSizeId !== 'custom',
        () => model.ingredientsSizeDesc
      ]
    }),
    ingredientsStyleDesc:
      props.data.ingredientsId === '' ? useMust(t('请填写款式说明')) : [],
    ingredientsMaterialsDesc:
      props.data.ingredientsId === '' ? useMust(t('请填写材质详细说明')) : [],
    ingredientsSizeDesc:
      props.data.ingredientsId === '' ? useMust(t('请填写尺寸详细说明')) : [],
    // 上传Logo
    isAppendLogo: useLeast({
      msg: t('请上传Logo'),
      fns: () =>
        model.logoUrl || model.isAppendLogo === 'B' || !model.isAppendLogo
    }),
    logoUrl: props.data.isAppendLogo === 'A' && useMust('请上传Logo'),
    // 产品名称
    productName: useRules({ message: t('请填写产品名称'), key: 'noblank' }),
    // 参考图片
    productImg: useLeast(productImg),
    // 参考链接
    productUrl: useLeast(productImg).concat(useRule('url')),
    // 产品信息
    searchSourceOrderSkuList: useLeast({
      msg: t('请至少填写一条完整的产品信息'),
      fns: () => model.searchSourceOrderSkuList?.length
    }).concat(useMust('')),
    // 尺寸模板
    sizeValue: useMust(t('请上传尺码表')),
    // 期望价格
    customerExpectPrice: useMust(t('请填写期望价格')),
    // 期望最低起订量
    customerExpectMinOrderQuantity: useMust(t('请填写期望最低起订量')),
    // 期望交期时间
    customerExpectDeliveryTime: useMust(t('请选择期望交期时间'))
  }
  return rules
}
